import gsap from "gsap";

const formFieldMapping = {
    'EmployeeBandDisplayName': 'rOINumberofEmployees',
    'IndustryDisplayName': 'rOIIndustry',
    'SegDisplayName': 'rOIPrimaryDefenseSolution',
    'AvgMalicious': 'rOINumberofSuspicousEmails',
    'LaborCost': 'rOIEstimatedLaborCosts',
    'LossExposure': 'rOIAnnualLossExposure',
    'TotalLoss': 'rOIAnnualPhishingLoss',
}
document.body.addEventListener("resetScroll", () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
})
document.body.addEventListener('increment', (evt) => {
    // only allow requests to the current server as well as myserver.com
    if (!evt.detail.sameHost) {
        evt.preventDefault();
    }


    gsap.from(".stats-card #number", {
        ease: "power2.out",
        y: 50,

        innerText: 0,
        duration: 5,
        snap: {
            innerText: 0.1
        },
    });


    if (document.querySelector(".roi-calculator-results-card .value")) {

        const dataElements = document.querySelectorAll('.roi-calculator-results-card .value');
        const formatNumber = (number) => {
            return new Intl.NumberFormat().format(number);
        };

        dataElements.forEach((element) => {
            const value = parseInt(element.innerText.replace(/,/g, ''));
            gsap.fromTo(element, {
                innerText: 0,
                y: 50,
            }, {
                ease: "ease",
                innerText: value,
                duration: 1.8,
                snap: {
                    innerText: 1
                },
                onUpdate: function () {
                    // During the animation, format the number with commas
                    element.innerText = formatNumber(Math.floor(parseFloat(element.innerText)));
                }
            });
        });

    }
});

const formId = 3247;
const signUpForm = document.querySelector(`form[data-widget="signUpForm"]`);

if(signUpForm) {
    signUpForm.setAttribute("id", `mktoForm_${formId}`);
    
    MktoForms2.loadForm("//get.cofense.com", "404-JHU-612", formId, (cb) => {
                   
        document.body.addEventListener("setFormValues", (evt) => {
            const {detail} = evt;
            if (!detail.sameHost) {
                evt.preventDefault();
            }

            let obj = {
                'rOIRiskReduction': '80%'
            };
            Object.keys(detail)
                .forEach(key => {
                    const mappedField = formFieldMapping[key];

                    if (mappedField) {
                        obj[mappedField] = detail[key];
                    }
                });

            cb.setValues(obj);
        });
    });
}